import mailStore from 'owa-mail-store/lib/store/Store';
import Item from 'owa-service/lib/contract/Item';

export function getItem(itemId: string): Item {
    return mailStore.items.get(itemId);
}
